import { QUERY_AUTH } from '../constants/query-params/auth';
import session from './session';
import makeUrl from './url/make-url';
import serializeQueryParams from './url/serialize-query-params';

export const clearAuthTokenAndUpdateUrl = () => {
    clearAuthTokenBasedOnQueryParam();

    clearAuthUrl();
};

export const clearAuthUrl = () => {
    const queryParams = serializeQueryParams();

    if (queryParams[QUERY_AUTH.CLEAR_AUTH] !== undefined) {
        delete queryParams[QUERY_AUTH.CLEAR_AUTH];
        const newUrl = makeUrl(window.location.pathname, {}, queryParams);

        window.history.replaceState({}, document.title, newUrl);
    }
};

export const clearAuthTokenBasedOnQueryParam = () => {
    const queryParams = serializeQueryParams();

    if (queryParams[QUERY_AUTH.CLEAR_AUTH] !== undefined) {
        session.clearAccessToken();
    }
};
